module.exports = __webpack_public_path__ + "static/media/MIAB9379-180730-51_Small.211d4399.jpg";